import _ from 'lodash'
import { AnswerSynonym, SynonymGrammar } from '@feedyou/schema'

export function expandSynonymsByGrammars(
  synonyms: AnswerSynonym[] = [],
  customGrammars: SynonymGrammar[],
  storages: Record<string, any> = {}
): string[] {
  const defaultGrammars = getDefaultGrammars()
  // In case custom grammars have the same grammar as default grammars, customs have priority
  const allGrammars = _.uniqBy([...customGrammars, ...defaultGrammars], 'grammar')

  return synonyms.reduce((synonyms: string[], synonym) => {
    const grammar = allGrammars.find(({ grammar }) => synonym === `{${grammar}}`)
    const storage = Object.keys(storages).find(storage => synonym === `{${storage}}`)

    if (grammar) {
      return [...synonyms, ...(grammar.sentences || [])]
    } else if (storage && Array.isArray(storages[storage])) {
      return [...synonyms, ...storages[storage]]
    } else if (storage && typeof storages[storage] === 'string') {
      return [...synonyms, storages[storage]]
    }

    return [...synonyms, synonym]
  }, [])
}

function getDefaultGrammars(): SynonymGrammar[] {
  return [
    {
      grammar: 'yes',
      sentences: ['ano', 'jo', 'jasně', 'určitě', 'yes', 'jop', 'sure', 'ok', 'oukej']
    },
    { grammar: 'no', sentences: ['ne', 'nope'] }
  ]
}
